import { render, staticRenderFns } from "./FunnelReportModal.vue?vue&type=template&id=28c12756&scoped=true&"
import script from "./FunnelReportModal.vue?vue&type=script&lang=js&"
export * from "./FunnelReportModal.vue?vue&type=script&lang=js&"
import style0 from "./FunnelReportModal.vue?vue&type=style&index=0&id=28c12756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c12756",
  null
  
)

export default component.exports